import { ActionButton, ActionStack, Icon, MessagePage } from '../components/common';
import { CUSTOMER_SIGNIN_PATH } from './joinOutcome';
import { MessagePatricia } from './MessagePatricia';

// `c14b` — an account we don't know (AC36–AC39).
//
// Signed in fine with Google or Microsoft, but that email is on no household,
// so nothing opens. DRAWN BY THE MESSAGE-PAGE FAMILY, and where the prototype
// differs the family wins (Freddi, 2026-09-14): the prototype's one
// word-sized pill is superseded by the two full-width 46px buttons every other
// customer door carries — the way out first, Patricia quiet beneath it.
//
// THE PAGE GIVES A STRANGER NOTHING: no hint whether the address exists on our
// side, and a revoked customer sees exactly this page too (AC38).
//
// THE PRIMARY READS *Sign in* (Freddi, 2026-09-14), not the prototype's *Try
// another account*. AC37 already required the same controls, sizes and icons
// as the dead-link door row 2 shipped, and that door's primary is *Sign in* —
// so the words match now as well, and a customer who has met both pages is
// offered one thing by one name rather than two.
export function CustomerRefused() {
  return (
    <MessagePage
      title="We can’t sign you in"
      lead="That account isn’t set up for Beeches Brook. If you board with us, Patricia will sort it in a minute."
      actions={
        <ActionStack>
          <ActionButton tone="primary" href={CUSTOMER_SIGNIN_PATH} icon={<Icon name="log-in" size={15} />}>
            Sign in
          </ActionButton>
          <MessagePatricia text="it’s " />
        </ActionStack>
      }
    />
  );
}
